<template>
    <q-page class="q-pa-md">
        <div class="row q-pt-md q-col-gutter-md">
            <div v-if="mostrarFormulario" class="col-md-4 col-12">
                <q-card class="q-pa-md">
                    <q-form @submit="guardarFormulario">
                        <div class="text-h6 q-mb-md">Nuevo Proveedor</div>
                        <q-select
                            :options="['Seguro', 'Agencia', 'Mecanico', 'Multas', 'Tenencia', 'Verificación', 'Corralón', 'Grua', 'Localizador', 'OtrasSanciones']"
                            v-model="formulario.tipo" outlined label="Tipo de Proveedor" class="q-mb-md" dense
                            required />
                        <q-input v-model="formulario.rfc" outlined label="RFC" class="q-mb-md" dense required />
                        <q-input v-model="formulario.razon_social" outlined label="Razón Social o Nombre de la Persona"
                            class="q-mb-md" dense required />
                        <q-input v-model="formulario.representante" outlined label="Representante" class="q-mb-md" dense
                            required />
                        <q-input v-model="formulario.domicilio_fiscal" outlined label="Domicilio" class="q-mb-md" dense
                            required />
                        <q-input v-model="formulario.correo" outlined label="Correo" class="q-mb-md" dense required />
                        <q-input v-model="formulario.telefono" mask="(###) ### - ####" outlined label="Teléfono"
                            class="q-mb-md" dense required />
                        <div class="row justify-between">
                            <q-btn flat icon="mdi-content-save" v-if="formulario._id != ''" label="Editar"
                                color="primary" @click="EditarItem()" class=" q-mt-md q-mr-sm" :loading="loadingBtnE">
                                <template v-slot:loading>
                                    <q-spinner-facebook />
                                </template>
                            </q-btn>

                            <q-btn flat icon="mdi-content-save" v-else label="Guardar" color="primary"
                                :loading="loadingBtnG" type="submit" class="q-mt-md q-mr-sm">
                                <template v-slot:loading>
                                    <q-spinner-facebook />
                                </template>
                            </q-btn>

                            <q-btn flat icon="mdi-delete" label="Eliminar" color="primary" :loading="loadingBtnD"
                                @click="DeleteItem()" class="q-mt-md q-mr-sm">
                                <template v-slot:loading>
                                    <q-spinner-facebook />
                                </template>
                            </q-btn>
                            <q-btn flat icon="mdi-close" label="Cerrar" color="negative" class="q-mt-md"
                                @click="mostrarFormulario = false" />
                        </div>
                    </q-form>
                </q-card>
            </div>

            <!-- Columna derecha: tabla ocupa más espacio si no hay formulario -->
            <div :class="mostrarFormulario ? 'col-md-8 col-12' : 'col-12'">
                <q-table dense title="Proveedores" class="shadow-1" :data="items" :loading="loading" :columns="columns"
                    color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-select
                            :options="['Seguro', 'Agencia', 'Mecanico', 'Multas', 'Tenencia', 'Verificación', 'Corralón', 'Grua', 'Localizador', 'OtrasSanciones']"
                            v-model="selectTipo" outlined label="Tipo de Proveedor" style="width: 200px;"
                            class="q-mr-sm q-my-md" dense required />

                        <q-btn outline ref="" color="primary" icon="mdi-refresh" label="Consultar"
                            @click="GetProveedores()" no-caps class="q-mr-sm q-my-md" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo" class="q-my-md"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="tipo" :props="props" @click="verItem(props.row)">{{ props.row.tipo }}</q-td>
                            <q-td key="rfc" :props="props" @click="verItem(props.row)">{{ props.row.rfc }}</q-td>
                            <q-td key="razon_social" :props="props" @click="verItem(props.row)">{{
                                props.row.razon_social }}</q-td>
                            <q-td key="representante" :props="props" @click="verItem(props.row)">{{
                                props.row.representante }}</q-td>
                            <q-td key="correo" :props="props" @click="verItem(props.row)">{{ props.row.correo }}</q-td>
                            <q-td key="telefono" :props="props" @click="verItem(props.row)">{{ props.row.telefono
                            }}</q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            loadingBtnG: false,
            loadingBtnE: false,
            loadingBtnD: false,
            loading: false,
            mostrarFormulario: false,

            columns: [
                { name: 'tipo', label: 'Tipo', field: 'tipo', align: 'center', sortable: true },
                { name: 'rfc', label: 'RFC', field: 'rfc', align: 'center', sortable: true },
                { name: 'razon_social', label: 'Razón Social o Nombre de la Persona', field: 'razon_social', align: 'center', sortable: true },
                { name: 'representante', label: 'Representante', field: 'representante', align: 'center', sortable: true },
                { name: 'correo', label: 'Correo', field: 'correo', align: 'center', sortable: true },
                { name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'center', sortable: true }
            ],
            formulario: {
                _id: '',
                tipo: '',
                rfc: '',
                razon_social: '',
                representante: '',
                correo: '',
                telefono: '',
                fecha_creacion: '',
                creador: '',
                estatus: 'Vigente'
            },
            initialPagination: {
                sortBy: 'rfc',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },

            selectTipo: ''
        };
    },
    computed: {
        items() {
            return this.$store.state.auth.listaProvedoresStore;
        },
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    created() {
    },
    methods: {
        nuevoItem() {
            this.mostrarFormulario = true
            this.formulario = {
                _id: '',
                tipo: '',
                rfc: '',
                razon_social: '',
                representante: '',
                correo: '',
                telefono: '',
                fecha_creacion: '',
                creador: '',
                estatus: 'Vigente'
            }
        },
        cerrarItem() {
            this.formulario = {
                _id: '',
                tipo: '',
                rfc: '',
                razon_social: '',
                representante: '',
                correo: '',
                telefono: '',
                fecha_creacion: '',
                creador: '',
                estatus: 'Vigente'
            }
            this.mostrarFormulario = false
        },
        verItem(item) {
            this.mostrarFormulario = true
            this.formulario = item
        },
        async GetProveedores() {
            if (this.selectTipo == '') {
                this.$q.notify({ position: 'top-right', type: 'negative', message: `Seleccione un tipo de Proveedor.` })
                return
            }
            this.loading = true
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/' + this.selectTipo)
                console.log(respuesa.data)
                this.$store.state.auth.listaProvedoresStore = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async guardarFormulario() {
            this.formulario.creador = this.adminStore.email
            this.loadingBtnG = true
            try {
                let respuesa = await axios.post('Catalogos/PostProveedor/', this.formulario)
                console.log(respuesa.data)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })
                this.formulario._id = respuesa.data._id
                this.$store.state.auth.listaProvedoresStore.push(this.formulario)
                this.loadingBtnG = false
                this.cerrarItem()
            } catch (error) {
                console.log(error)
                this.loadingBtnG = false
                this.$q.notify({ position: 'top-right', type: 'negative', message: error.response.data })
                console.log(error)
            }
        },
        async EditarItem() {
            this.loadingBtnE = true
            try {
                let respuesa = await axios.put('Catalogos/PutProveedores/', this.formulario)
                console.log(respuesa.data)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Información guardada exitosamente.` })

                const index = this.$store.state.auth.listaProvedoresStore.findIndex(p => p._id === this.formulario._id)
                this.$set(this.$store.state.auth.listaProvedoresStore, index, { ...this.formulario })

                this.loadingBtnE = false
                this.cerrarItem()

            } catch (error) {
                this.loadingBtnE = false
                this.$q.notify({ position: 'top-right', type: 'warning', message: `Error al guardar el item, intntelo de nuevo.` })
                console.log(error)
            }
        },

        async DeleteItem() {
            this.loadingBtnD = true
            try {
                let respuesa = await axios.put('Catalogos/DeleteProveedores/' + this.formulario._id + '/Eliminado')
                console.log(respuesa.data)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `Item eliminado exitosamente.` })

                const index = this.$store.state.auth.listaProvedoresStore.findIndex(p => p._id === this.formulario._id)
                if (index !== -1) {
                    this.$store.state.auth.listaProvedoresStore.splice(index, 1)
                }

                this.mostrarFormulario = false
                this.formulario = {}
                this.loadingBtnD = false
            } catch (error) {
                this.loadingBtnD = false
                this.$q.notify({ position: 'top-right', type: 'warning', message: `Error al guardar el item, intntelo de nuevo.` })
                console.log(error)
            }
        }
    }
};
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}
</style>